import { cpfMask, phoneMask } from "../utils/functions";
import { ColumnDirective, ColumnsDirective, Filter, ExcelFilter, ColumnChooser, ExcelExport, Toolbar, GridComponent, Inject, Page, Sort } from "@syncfusion/ej2-react-grids";
import { useContext } from "react";
import AuthContext from "../../context/authProvider";

const UsersList = ({ users }) => {

    const { user } = useContext(AuthContext);

    let grid;

    const handleQueryCellInfo = (args) => {
        if (args.column.field === "admin" || args.column.field === "partner") {
            args.cell.style.color = "green";
        }
    };

    const filterSettings = { type: 'Excel' };

    let toolbarOptions = ['ColumnChooser'];
    let allowExcelExport = false;

    if (user.roles.includes("master")) {
        toolbarOptions = ['ExcelExport', 'ColumnChooser'];
        allowExcelExport = true;
    }

    const toolbarClick = (args) => {
        console.log("Tollbar clicked.");
        if (grid && args.item.id === 'Grid_excelexport') {
            console.log("Tollbar clicked. => Grid_excelexport");
            grid.excelExport();
        }
    };

    return (
        <GridComponent id='Grid' toolbar={toolbarOptions} dataSource={users} filterSettings={filterSettings} allowExcelExport={allowExcelExport} allowSorting allowFiltering allowPaging queryCellInfo={handleQueryCellInfo} pageSettings={{ pageSize: 30 }} toolbarClick={toolbarClick} ref={g => grid = g} showColumnChooser>
            <ColumnsDirective>
                <ColumnDirective field='name' headerText="Nome" width='100' textAlign="Center" />
                <ColumnDirective field='email' headerText="Email" width='100' textAlign="Center" />
                <ColumnDirective field='documentNumber' width='100' headerText="CPF" textAlign="Center" valueAccessor={(f, d) => { return cpfMask(d?.documentNumber) }} />
                <ColumnDirective field='createdAt' width='100' headerText="Criado" textAlign="Center" type="date" format="dd/MM/yyyy" />
                <ColumnDirective field='birth' visible={false} width='100' headerText="Nascimento" textAlign="Center" type="date" format="dd/MM/yyyy" />
                <ColumnDirective field='phone' width='100' headerText="Telefone" textAlign="Center" valueAccessor={(f, d) => { return phoneMask(d?.phone) }} />
                <ColumnDirective field='admin' width='100' headerText="Admin" textAlign="Center" valueAccessor={(f, d) => { return d?.roles?.includes("admin") ? "✔" : null }} />
                <ColumnDirective field='partner' width='100' headerText="Parceiro" textAlign="Center" valueAccessor={(f, d) => { return d?.roles?.includes("partner") ? "✔" : null }} />
                <ColumnDirective width='100' textAlign="Center" template={(d, f) => { return <a href={`/manafix/users/${d?._id}`} className="bg-blue-500 hover:bg-blue-800 px-2 text-black">Ver</a> }} />
            </ColumnsDirective>
            <Inject services={[Sort, Page, Filter, ExcelFilter, ColumnChooser, ExcelExport, Toolbar]} />
        </GridComponent>
    )
}

export default UsersList;